<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
        </div>
        <div class="modules-explanation">
            {{ $LANG.Get('texts.modulesExplanation') }}
        </div>
        <NevsCard class="form">
            <NevsCheckbox v-for="module in modules" :key="module.module" v-model="module.visible" :label="$LANG.Get('modules.' + module.module)"></NevsCheckbox>
        </NevsCard>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";

export default {
    name: "ModulesSettings",
    components: {
        NevsCard,
        NevsCheckbox,
        NevsButton
    },
    data() {
        return {
            modules: []
        }
    },
    methods: {
        saveClick() {
            let valid = true;

            if (valid) {
                let vm = this;
                this.$API.APICall('post', 'client/modules', {modules: this.modules}, (data, success) => {
                    if (success) {
                        window.location.reload(true);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', []);

        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR')) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'modulesSettings');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.modules'),
                link: null
            }
        ]);

        let vm = this;
        this.$API.APICall('get', 'client', {}, (data, success) => {
            if (success) {
                let allModules = data.client.all_modules;
                let hiddenModules = data.client.hidden_modules;
                for (let i = 0; i < allModules.length; i++) {
                    vm.modules.push({
                        module: allModules[i],
                        visible: !hiddenModules.includes(allModules[i])
                    });
                }
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 800px;
    margin-bottom: 10px;
}
.modules-explanation {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>